import React, { useEffect, useState } from "react";
import { globalFileServer } from "../../../../axiosInstance";
import ProductInfo from "../../productInfo/ProductInfo";
import { useSelector } from "react-redux";

const Detailes = ({
  element,
  inCart,
  productPopUp,
  comparePricesPopUp,
  srcPrev,
}) => {
  const { stationId, role } = useSelector((state) => ({
    role: state.user.role,
    stationId: state.user.stationId,
  }));

  const [mediaIndex, setMediaIndex] = useState(element.media?.length - 1);

  const handleError = () => {
    if (mediaIndex > 0) {
      setMediaIndex(prev => prev - 1);
    } else {
      setMediaIndex(-1); 
    }
  };

  return (
    <>
      <div className="item-card-details" onClick={productPopUp}>
        <div
          className={inCart ? "card-img-in-card" : "card-img"}
          style={srcPrev ? { width: "190px" } : { width: "none" }}
        >
          <img
            className="img"
            loading="lazy"
            src={
              srcPrev != null 
                ? srcPrev 
                : (mediaIndex >= 0 && element.media[mediaIndex]?.path)
                  ? `${globalFileServer}products/${element.media[mediaIndex].path}?width=150&height=150`
                  : `${globalFileServer}placeholder.jpg`
            }
            onError={handleError}
          />
        </div>
        <div className="desc">
          <span className="product-info">
            <ProductInfo selectedProd={element} />
          </span>
          <div className="kosher-and-price">
            {element.pricing && element.pricing.promotions?.lengh && (
              <span className="current-price">
                {parseFloat(element.pricing.promotions[0]).toFixed(2)}
              </span>
            )}

            <div className="price-main-cont">
              {element.pricing ? (
                <span
                  className={
                    element.pricing["promotions"]?.lengh
                      ? "price with-sale"
                      : "current-price"
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    comparePricesPopUp();
                  }}
                  data-tip
                  data-for="registerTipComparePrice"
                >
                  {element.pricing["price"]}
                </span>
              ) : null}
            </div>
            {element.kosherSupervision?.length ? (
              <div className="prod-info-kosher">
                <>
                  <img
                    loading="lazy"
                    src={
                      globalFileServer + "iconcss/" + element.KashrutId + ".svg"
                    }
                    alt={element.kosherSupervision[0].supervisionAgency}
                  />
                </>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default Detailes;
